import React, { useContext, useEffect, useRef } from 'react'
import styles from './SidebarFields.module.css'
import { fields } from '../AvailableFields/FieldDefinitions'
import DraggableSidebarField from './components/DraggableFields/DraggableSidebarField'
import { observer } from 'mobx-react-lite'
import { categoriesFields } from '../AvailableFields/FieldDefinitions'
import PanelSidebarFields from '../../../../components/Sidebar/Builder/PanelSidebarFields'

import { BuilderContext } from '../store/store.Builder'

const SidebarFields = observer(() => {
  const builderContext = useContext(BuilderContext)

  const renderCountRef = useRef(0)
  renderCountRef.current += 1

  useEffect(() => {
    console.log(`SidebarFields render count: ${renderCountRef.current}`)
  })

  return (
    <div
      className={`${styles.sidebarFields} ${
        builderContext.isSidebarFieldsOpen ? '' : styles.hidden
      }`}
    >
      <PanelSidebarFields title="Élements">
        <div className={styles.all_fields_content}>
          {Object.values(categoriesFields).map((category) => (
            <div className={styles.section__content}>
              <div className={styles.title_category}>{category.title}</div>
              <div className={styles.container}>
                <section
                  key={builderContext.sidebarFieldsRegenKey}
                  className={styles.content}
                >
                  {category.fields.map((f) => (
                    <DraggableSidebarField key={f.type} field={f} />
                  ))}
                </section>
              </div>
            </div>
          ))}
        </div>
      </PanelSidebarFields>
    </div>
  )
})

export default SidebarFields
